import { Fade, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { ButtonWrapper, TitleText } from "../../../../shared/components/FailModal/Styled";
import { InputWrapper } from "../../../../shared/components/FormType/Styled";
import TextBox from "../../../../shared/components/TextBox";
import CustomButton from "../../../../shared/components/TitleRow/CustomButton";
import { ModalWrapper, StyledBackdrop } from "../../../ProductOrder/single/AddProductModal/Styled";
import { TitleWrapper } from "../../../ProductOrder/Styled";

interface AddCategoryGroupModalProps {
    open: boolean;
    handleClose: () => void;
    handleConfirm: (name: string) => Promise<void>;
}

const AddCategoryGroupModal = ({ open, handleClose, handleConfirm }: AddCategoryGroupModalProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const [name, setName] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!open) {
            setIsOpen(false);
            const timer = setTimeout(() => {
                handleClose();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [open, handleClose]);

    const handleCloseWithAnimation = () => {
        if (isSubmitting) return;
        setTimeout(handleClose, 100);
    };

    const handleConfirmWithAnimation = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await handleConfirm(name);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            open={open}
            onClose={handleCloseWithAnimation}
            closeAfterTransition
            BackdropComponent={StyledBackdrop}
            BackdropProps={{
                timeout: 500,
                onClick: (e) => e.stopPropagation(),
            }}
        >
            <Fade in={isOpen} timeout={500}>
                <ModalWrapper isOpen={isOpen} style={{width: "20vw", minHeight: "auto"}}>
                    <TitleWrapper>
                        <TitleText>Thêm nhóm danh mục vật tư</TitleText>
                    </TitleWrapper>
                    
                    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                        <span style={{ fontSize: "16px", fontWeight: "600", color: "#333" }}>Tên nhóm danh mục</span>
                        <InputWrapper>
                            <TextBox
                                text={name}
                                onChangeText={setName}
                                numeric={false}
                                placeholder="Nhập tên nhóm danh mục"
                            />
                        </InputWrapper>
                    </div>

                    <ButtonWrapper>
                        <CustomButton
                            title="Đóng"
                            onClick={handleCloseWithAnimation}
                            disabled={isSubmitting}
                            style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                display: "flex",
                                justifyContent: "center",
                                width: "60%",
                                minWidth: "120px",
                            }}
                        />
                        <CustomButton
                            title="Thêm"
                            variant="contained"
                            onClick={handleConfirmWithAnimation}
                            disabled={!name}
                            isLoading={isSubmitting}
                            style={{
                                paddingTop: 8,
                                paddingBottom: 8,
                                display: "flex",
                                justifyContent: "center",
                                width: "60%",
                                minWidth: "120px",
                            }}
                        />
                    </ButtonWrapper>
                </ModalWrapper>
            </Fade>
        </Modal>
    );
};

export default AddCategoryGroupModal;
